<template>
  <div
    class="cookie-backdrop"
    v-show="bannerVisibility"
  >
    <div class="cookie-modal container-fluid">
      <div
        class="cookie-content"
        v-if="slide === 'init'"
      >
        <div class="row">
          <h3 class="secondary-heading">
            Szanujemy Twoją prywatność
          </h3>
        </div>
        <div class="row">
          <p>
            Na stronie internetowej używamy plików cookies lub podobnych technologii i umożliwiamy ich
            umieszczanie naszym zewnętrznym dostawcom wskazanym w Polityce cookies w celach analitycznych i
            statystycznych, dostosowywania strony do indywidualnych potrzeb Użytkowników, społecznościowych
            oraz w celach reklamowych.
          </p>
          <p>
            Jeżeli wyrażasz zgodę na przetwarzania Twoich danych w powyższych celach, kliknij „Akceptuję”.
            Możesz cofnąć swoją zgodę lub sprzeciwić się, korzystając z możliwości kontynuacji nie
            akceptując plików cookies, zarządzania ustawieniami plików cookies, a także poprzez zmianę
            ustawień Twojej przeglądarki.
          </p>
          <p>
            Na stronie internetowej używamy również niezbędnych plików cookies w celu zapewnienia poprawnego
            i bezpiecznego funkcjonowania strony.
          </p>
          <p>
            Administratorem Twoich danych osobowych jest Volkswagen Group Polska Sp. z o.o. Więcej informacji
            dot. przetwarzania danych osobowych oraz korzystania z plików cookies w
            <a
              target="_blank"
              href="http://www.skoda-auto.pl/inne/polityka_prywatnosci"
            >
              Polityce
              prywatności
            </a> oraz w
            <a
              target="_blank"
              href="https://www.skoda-auto.pl/inne/polityka-plikow-cookies"
            >
              Polityce plików cookies.
            </a>
          </p>
        </div>
        <div class="row text-center">
          <div class="cookie-buttons">
            <button
              class="btn btn-cookie btn-cookie--discard"
              @click="onDiscardClick"
            >
              Nie akceptuję
            </button>
            <button
              class="btn btn-cookie btn-cookie--accept"
              @click="onAcceptAllClick"
            >
              Akceptuję
            </button>
          </div>
          <div class="cookie-links">
            <button
              class="btn btn-cookie btn-cookie--link"
              @click="onConfigClick"
            >
              Zmień ustawienia
            </button>
          </div>
        </div>
      </div>
      <div
        class="cookie-content"
        v-else-if="slide === 'config'"
      >
        <h3 class="secondary-heading">
          Ustawienia plików cookie
        </h3>
        <div class="cookie-radios">
          <div>
            <label
              for="discardAll"
              class="cookie-label"
            >
              <input
                type="radio"
                name="radio"
                class="standard-radio"
                id="discardAll"
                v-model="radioControl"
                :value="0"
              >
              Odrzuć wszystko
            </label>
          </div>
          <div>
            <label
              for="acceptAll"
              class="cookie-label"
            >
              <input
                type="radio"
                name="radio"
                class="standard-radio"
                id="acceptAll"
                v-model="radioControl"
                :value="1"
              >
              Akceptuj wszystko
            </label>
          </div>
        </div>
        <div class="row">
          <p>
            Klikając „akceptuj wszystko” w prawym górnym rogu, zgadzasz się na przetwarzanie Twoich danych
            osobowych w celach analitycznych i statystycznych, dostosowywania strony do indywidualnych
            potrzeb Użytkowników, społecznościowych oraz w celach reklamowych.
          </p>
          <p>
            Poniżej masz możliwość zaakceptowania lub odrzucenia określonych kategorii plików cookies, poza
            niezbędnymi plikami cookies, których używamy w celu zapewnienia poprawnego i bezpiecznego
            funkcjonowania strony.
          </p>
          <p>
            Więcej informacji dot. przetwarzania danych osobowych, korzystania z plików cookies oraz
            informacji o
            dostawcach w zakresie plików cookies w
          </p>
          <a
            target="_blank"
            href="https://www.skoda-auto.pl/inne/polityka-plikow-cookies"
          >
            Polityce plików cookies.
          </a>
          <p>W ramach Serwisu stosowane są następujące pliki cookies:</p>
        </div>
        <ul class="row">
          <li>
            <label
              for="strictCookies"
              class="standard-input-container cookie-label"
            >
              <input
                class="standard-checkbox"
                type="checkbox"
                v-model="cookiesConsents.strictCookies"
                id="strictCookies"
                checked
                disabled
              >
              <strong>„niezbędne” pliki cookies</strong> - niezbędne do funkcjonowania strony
              internetowej, umożliwiające korzystanie z usług dostępnych w ramach Serwisu, np.
              uwierzytelniające pliki cookies wykorzystywane do usług wymagających uwierzytelniania w
              ramach Serwisu; służące do zapewnienia bezpieczeństwa, np. wykorzystywane do wykrywania
              nadużyć w zakresie uwierzytelniania w ramach Serwisu.
            </label>
          </li>
          <li>
            <label
              for="analyticCookies"
              class="standard-input-container cookie-label"
            >
              <input
                class="standard-checkbox"
                type="checkbox"
                v-model="cookiesConsents.analyticCookies"
                id="analyticCookies"
              >
              <strong>„analityczne”/„wydajnościowe” pliki cookies</strong> - umożliwiające
              zbieranie informacji o sposobie korzystania ze stron internetowych, aby pomóc nam zrozumieć,
              w jaki sposób wykorzystywane są nasze witryny internetowe lub pomóc nam w dostosowaniu
              naszych stron internetowych; te pliki cookie pozwalają nam na zliczanie wizyt i źródeł ruchu
              w naszej witrynie, dzięki czemu możemy mierzyć i usprawniać jej działanie. Dzięki nim możemy
              dowiedzieć się, które strony są najbardziej, a które najmniej popularne, a także zrozumieć,
              jak odwiedzający poruszają się po naszej witrynie. Wszystkie dane gromadzone przez te pliki
              cookie są agregowane, w związku z czym pozostają anonimowe. Jeśli użytkownik nie wyrazi
              zgody na stosowanie tych plików cookie, nie będziemy wiedzieć, kiedy odwiedził naszą
              witrynę, ani nie będziemy w stanie monitorować jej działania. Bez tych plików cookie
              niektóre funkcje mogą stać się niedostępne.
            </label>
          </li>
          <li>
            <label
              for="functionalityCookies"
              class="standard-input-container cookie-label"
            >
              <input
                class="standard-checkbox"
                type="checkbox"
                v-model="cookiesConsents.functionalityCookies"
                id="functionalityCookies"
              >
              <strong>„funkcjonalne” pliki cookies</strong>- umożliwiające „zapamiętanie”
              wybranych przez Użytkownika ustawień i personalizację interfejsu Użytkownika, np. w zakresie
              wybranego języka lub regionu, z którego pochodzi Użytkownik, rozmiaru czcionki, wyglądu
              strony internetowej itp. Zadaniem tych plików cookie jest umożliwienie użytkownikowi
              korzystania z naszej witryny w sposób lepiej dostosowany do jego osobistych preferencji w
              oparciu o jego wcześniejsze wizyty i wybrane ustawienia. Jeśli użytkownik nie wyrazi zgody
              na używanie tych plików cookie, niektóre funkcje strony mogą nie działać prawidłowo.
            </label>
          </li>
          <li>
            <label
              for="marketingCookies"
              class="standard-input-container cookie-label"
            >
              <input
                class="standard-checkbox"
                type="checkbox"
                v-model="cookiesConsents.marketingCookies"
                id="marketingCookies"
              >
              <strong>„reklamowe” pliki cookies</strong> - umożliwiające dostarczanie
              Użytkownikom
              treści reklamowych bardziej dostosowanych do ich preferencji i zainteresowań, odwiedzin na
              stronach internetowych, także poprzez działania remarketingowe z użyciem tzw. (ang.) third
              party cookies (ciasteczka stron trzecich) umieszczanych za pośrednictwem naszej strony przez
              naszych dostawców reklamowych. Mogą one być wykorzystane do tworzenia profili Użytkowników,
              prezentowania bardziej trafnych lub odpowiadających profilowi reklam na innych stronach,
              zapobieganiu ponownemu pojawianiu się tej samej reklamy, a także do mierzenia efektywność
              kampanii reklamowych. Pliki te mogą przechowywać informacje o fakcie, że witryna internetowa
              została odwiedzona z określonego urządzenia, a także przekazywać tego rodzaju dane partnerom
              reklamowym. Nie wyrażenie zgody na te pliki cookies nie uniemożliwia korzystania z
              serwisu.
            </label>
          </li>
          <li>
            <label
              for="socialCookies"
              class="standard-input-container cookie-label"
            >
              <input
                class="standard-checkbox"
                type="checkbox"
                v-model="cookiesConsents.socialCookies"
                id="socialCookies"
              >
              <strong>„społecznościowe” pliki cookies</strong> - służą do udostępniania stron i
              treści naszych stron internetowych za pośrednictwem zewnętrznych sieci społecznościowych i
              innych witryn internetowych. Podczas dzielenia się informacjami przy użyciu funkcji
              udostępniania w ramach sieci społecznościowych zbudowanych wokół portali społecznościowych
              lub przycisku „Lubię to”, a także po powiązaniu konta na portalu społecznościowym z naszą
              stroną lub korzystania z treści zamieszczanych przez nas na stronach serwisów
              społecznościowych. Sieć społecznościowa rejestruje tego rodzaju działania Użytkownika. Tego
              rodzaju informacje mogą być wykorzystywane w działaniach reklamowych lub do kierowania
              reklam na określoną grupę docelową. Nie wyrażenie zgody na te pliki cookies nie uniemożliwia
              korzystania z serwisu.
            </label>
          </li>
        </ul>
        <div class="cookie-buttons">
          <button
            class="btn btn-cookie btn-cookie--accept"
            @click="onSaveClick()"
          >
            Zapisz i zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import trackPageview from '@/helpers/track-pageview';

export default {
  data() {
    const self = this;

    return {
      slide: 'init',
      radioControl: 0,
      bannerVisibility: false,
      cookiesConsents: {
        strictCookies: true,
        analyticCookies: false,
        functionalityCookies: false,
        marketingCookies: false,
        socialCookies: false,
      },
      cookiesScripts: {
        analyticCookies: [
          {
            callScript() {
              const env = process.env.NODE_ENV;

              if (env === 'production') {
                /* eslint-disable */
                  (function (w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({
                      'gtm.start':
                        new Date().getTime(),
                      event: 'gtm.js'
                    });
                    var f = d.getElementsByTagName(s)[0],
                      j = d.createElement(s),
                      dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src =
                      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                  })(window, document, 'script', 'dataLayer', 'GTM-TG4WHRG');
                  /* eslint-enable */

                trackPageview(self.$route.name, self.$route.path);
              }
            },
          },
        ],
      },
    };
  },
  computed: {
    cookiesConsentsNames() {
      return Object.keys(this.cookiesConsents);
    },
  },
  methods: {
    areCookiesConsentsSet() {
      const consentsAlreadySet = this.cookiesConsentsNames.filter(name => localStorage.getItem(name));
      return consentsAlreadySet.length === this.cookiesConsentsNames.length;
    },
    getCookiesConstents() {
      this.cookiesConsentsNames.forEach((name) => {
        const consentValue = localStorage.getItem(name);

        if (consentValue !== null) {
          this.cookiesConsents[name] = consentValue === 'true';
        }
      });
    },
    acceptAll(shouldSetLocalStorage = false) {
      this.cookiesConsentsNames
        .forEach((name) => {
          this.cookiesConsents[name] = true;
          if (shouldSetLocalStorage) localStorage.setItem(name, true);
        });
    },
    discardAll(shouldSetLocalStorage = false) {
      this.cookiesConsentsNames
        .forEach((name) => {
          const value = name === 'strictCookies';
          this.cookiesConsents[name] = value;
          if (shouldSetLocalStorage) localStorage.setItem(name, value);
        });
    },
    onAcceptAllClick() {
      this.acceptAll(true);
      this.bannerVisibility = false;
      this.callThirdPartyScripts();
    },
    onDiscardClick() {
      this.discardAll(true);
      this.bannerVisibility = false;
      this.callThirdPartyScripts();
    },
    onConfigClick() {
      this.slide = 'config';
    },
    onSaveClick() {
      this.cookiesConsentsNames.forEach(name => localStorage.setItem(name, this.cookiesConsents[name]));
      this.bannerVisibility = false;
      this.callThirdPartyScripts();
    },
    callThirdPartyScripts() {
      this.cookiesConsentsNames.forEach((name) => {
        if (this.cookiesConsents[name] && this.cookiesScripts[name] !== undefined) {
          this.cookiesScripts[name].forEach(thirdPartyScript => thirdPartyScript.callScript());
        }
      });
    },
  },
  watch: {
    radioControl(newVal) {
      if (newVal === 0) this.discardAll();
      if (newVal === 1) this.acceptAll();
    },
    cookiesConsents: {
      deep: true,
      handler(newObj) {
        const acceptedArray = Object.keys(newObj)
          .filter(name => newObj[name]);
        const allAccepted = acceptedArray.length === 1;
        const allDiscarded = acceptedArray.length === this.cookiesConsentsNames.length;

        if (!allAccepted && !allDiscarded) {
          this.radioControl = 2;
        }
      },
    },
  },
  mounted() {
    this.bannerVisibility = !this.areCookiesConsentsSet();

    this.getCookiesConstents();

    if (!this.bannerVisibility) {
      this.callThirdPartyScripts();
    }
  },
};
</script>
